import * as t from 'io-ts';

import {makeApiType, RInboxIdRef, RLazyTeammateIdRef, RTagIdRef} from './apiTypes';

/*
 * Runtime type.
 */

const RDelegationDirty = t.readonly(
  t.type({
    id: t.Integer,
    ownerId: RLazyTeammateIdRef,
    isFull: t.boolean,
    teammateIds: t.readonlyArray(RLazyTeammateIdRef),
    inboxIds: t.readonlyArray(RInboxIdRef),
    customViewIds: t.readonlyArray(RTagIdRef),
    updatedAt: t.Integer,
  }),
  'delegation',
);

/*
 * Type.
 */

export interface DelegationModel extends t.TypeOf<typeof RDelegationDirty> {}
export const RDelegation = t.clean<DelegationModel>(RDelegationDirty as any);

/*
 * IO methods.
 */

export function parseDelegation(src: any): DelegationModel {
  return {
    id: src.id,
    ownerId: src.owner_id,
    isFull: Boolean(src.is_full),
    teammateIds: src.teammate_ids,
    inboxIds: src.inbox_ids,
    customViewIds: (src.custom_views && src.custom_views.map((c: any) => c.meta.tag_id)) || [],
    updatedAt: src.updated_at,
  };
}

/*
 * API type.
 */

export const ApiDelegation = makeApiType('delegation', RDelegationDirty, parseDelegation);
